import { render, staticRenderFns } from "./PrimaryTitle.vue?vue&type=template&id=3e2e7c4b&scoped=true&"
import script from "./PrimaryTitle.vue?vue&type=script&lang=js&"
export * from "./PrimaryTitle.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryTitle.vue?vue&type=style&index=0&id=3e2e7c4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2e7c4b",
  null
  
)

export default component.exports